/**
 * @file コンポーネント：見出し ロジック管理
 * @license Copyright 2021 OPExPARK Inc.
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Headline = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
